export default "__VITE_ASSET__CZPuDap3__"